import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import { formatCellValue } from './AuditLogPanel.utils';

interface Props {
	value: unknown;
}

function AuditLogCellValue({ value }: Props) {
	const { display, full } = formatCellValue(value);
	if (full) {
		return (
			<Tooltip
				title={
					<pre style={{ margin: 0, fontSize: 11, maxWidth: 400, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
						{full}
					</pre>
				}
				placement="top"
			>
				<span style={{ cursor: 'help', textDecoration: 'underline dotted', textUnderlineOffset: 2 }}>
					{display}
				</span>
			</Tooltip>
		);
	}
	return <>{display}</>;
}

export default AuditLogCellValue;
